import { LocalizedStrings } from '@getgo/g2r-shared-components';
import * as React from 'react';
import Loader from 'react-loader-spinner';
import { ErrorPage } from '../../components/ErrorPage/ErrorPage';
import { Wrapper } from '../../components/Wrapper/Wrapper';
import { CurrentUser, SettingsContext, SettingsKeeper, SettingsKeeperState } from '../../contexts/SettingsKeeper';
import { createLogger } from '../../helpers/Logger';
import { Lang } from '../../helpers/Polyglot';
import { Activation } from '../Activation/Activation';
import styles from './App.scss';

export class App extends React.Component {
    logger = createLogger('AppComponent');
    state = { error: null, errorInfo: null };

    private getContent = (currentUser: CurrentUser, language: string, userError: boolean): any =>  {
        if (currentUser && currentUser.key && language !== '') {
            return( <Wrapper>
                <Activation currentUser={currentUser} accounts={currentUser.accounts} />
            </Wrapper>);
        } else if (userError) { this.setState({error: userError, errorInfo: ''});
        } else { return(<Loader type={'Oval'} color={'#00BFFF'}/>); }
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        this.logger.info(`ERROR: ${error.toString()}, INFO: ${errorInfo.componentStack}`);
        this.setState({error: error.toString(), errorInfo});
    }

    render() {
        if (this.state.error) {
            return(<div className={styles.App}><Wrapper><ErrorPage errorDetails={this.state.error}/></Wrapper></div>);
        }
        return (
          <div className={styles.App}>
              <SettingsKeeper>
                  <SettingsContext.Consumer>
                      {
                          ({ language, timezone, timeFormat, currentUser, userError }: SettingsKeeperState) => (
                              <>
                                  <LocalizedStrings strings={Lang.getPhrases(language) as any} locale={language} keyboard=''>
                                      {this.getContent(currentUser, language, userError)}
                                  </LocalizedStrings>
                              </>
                          )
                      }
                  </SettingsContext.Consumer>
              </SettingsKeeper>
          </div>
        );
    }
}
